module.exports = __webpack_public_path__ + "public/img/bank.378bcce.png";